import type {
  OrganizationAccess
} from "@camp-points/shared";
import { useState } from "react";
import { BrandShell } from "../components/BrandShell";
import {
  changePin
} from "../lib/api";

export function ChangePinPage({
  organization,
  forced,
  onComplete
}: {
  organization: OrganizationAccess;
  forced: boolean;
  onComplete: () => Promise<void>;
}) {
  const [currentPin, setCurrentPin] =
    useState("");
  const [newPin, setNewPin] =
    useState("");
  const [confirmPin, setConfirmPin] =
    useState("");
  const [error, setError] =
    useState("");
  const [saving, setSaving] =
    useState(false);

  async function submit(
    event: React.FormEvent
  ) {
    event.preventDefault();
    setError("");

    if (newPin !== confirmPin) {
      setError(
        "The new PIN entries do not match."
      );
      return;
    }

    setSaving(true);

    try {
      await changePin({
        organizationId:
          organization.organizationId,
        ...(forced
          ? {}
          : { currentPin }),
        newPin
      });

      await onComplete();
    } catch (caught) {
      setError(
        caught instanceof Error
          ? caught.message
          : "The PIN could not be changed."
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <BrandShell
      branding={organization.branding}
      eyebrow={
        forced
          ? "First login"
          : "Account security"
      }
    >
      <p className="lead">
        {forced
          ? "Choose a personal PIN before using the system."
          : "Change your current PIN."}
      </p>

      <form onSubmit={submit}>
        {!forced && (
          <label>
            Current PIN
            <input
              type="password"
              inputMode="numeric"
              value={currentPin}
              onChange={(event) =>
                setCurrentPin(
                  event.target.value
                )
              }
            />
          </label>
        )}

        <label>
          New PIN
          <input
            type="password"
            inputMode="numeric"
            value={newPin}
            onChange={(event) =>
              setNewPin(
                event.target.value
              )
            }
            minLength={4}
            maxLength={8}
          />
        </label>

        <label>
          Confirm new PIN
          <input
            type="password"
            inputMode="numeric"
            value={confirmPin}
            onChange={(event) =>
              setConfirmPin(
                event.target.value
              )
            }
            minLength={4}
            maxLength={8}
          />
        </label>

        {error && (
          <p className="error-message">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={
            saving ||
            newPin.length < 4
          }
        >
          {saving
            ? "Saving…"
            : "Save PIN"}
        </button>
      </form>
    </BrandShell>
  );
}
